'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './gp.routes';

export class GpComponent {
  /*@ngInject*/
  constructor($http, $scope, $timeout) {
    this.$http = $http;
    this.$scope = $scope;
    this.$timeout = $timeout;

    this.$scope.downloadDataLink = '';
    this.$scope.downloadLink = '';
  }

  $onInit() {
    function initTheme() {
      var transparent = true;
      var big_image;

      var transparentDemo = true;
      var fixedTop = false;

      var navbar_initialized,
        backgroundOrange = false,
        toggle_initialized = false;

      var nowuiKit,
        $navbar,
        $toggle,
        scroll_distance,
        oVal;

      $(document).ready(function () {
        //  Activate the Tooltips
        $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();

        //    Activate bootstrap-select
        if ($(".selectpicker").length != 0) {
          $(".selectpicker").selectpicker({
            iconBase: "now-ui-icons",
            tickIcon: "ui-1_check"
          });
        };

        if ($(window).width() >= 768) {
          big_image = $('.header[data-parallax="true"]');
          if (big_image.length != 0) {
            $(window).on('scroll', nowuiKit.checkScrollForParallax);
          }
        }

        // Activate Popovers and set color for popovers
        $('[data-toggle="popover"]').each(function () {
          color_class = $(this).data('color');
          $(this).popover({
            template: '<div class="popover popover-' + color_class + '" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
          });
        });

        //Activate tags
        // we style the badges with our colors
        var tagClass = $('.tagsinput').data('color');

        if ($(".tagsinput").length != 0) {
          $('.tagsinput').tagsinput();
        }

        $('.bootstrap-tagsinput').addClass('badge-' + tagClass + '');

        // Activate the image for the navbar-collapse
        nowuiKit.initNavbarImage();

        // Adding class show on the navbar-collapse for animation working properly
        $('.navbar-collapse').addClass('show');

        $navbar = $('.navbar[color-on-scroll]');
        scroll_distance = 50;
        // scroll_distance = $navbar.attr('color-on-scroll') || 500;

        // Check if we have the class "navbar-color-on-scroll" then add the function to remove the class "navbar-transparent" so it will transform to a plain color.
        if ($('.navbar[color-on-scroll]').length != 0) {
          nowuiKit.checkScrollForTransparentNavbar();
          $(window).on('scroll', nowuiKit.checkScrollForTransparentNavbar)
        }

        $('.form-control').on("focus", function () {
          $(this).parent('.input-group').addClass("input-group-focus");
        }).on("blur", function () {
          $(this).parent(".input-group").removeClass("input-group-focus");
        });

        // Activate bootstrapSwitch
        $('.bootstrap-switch').each(function () {
          $this = $(this);
          data_on_label = $this.data('on-label') || '';
          data_off_label = $this.data('off-label') || '';

          $this.bootstrapSwitch({
            onText: data_on_label,
            offText: data_off_label
          });
        });

        if ($(window).width() >= 992) {
          big_image = $('.page-header-image[data-parallax="true"]');

          $(window).on('scroll', nowuiKit.checkScrollForParallax);
        }


      });

      $(window).on('resize', function () {
        nowuiKit.initNavbarImage();
      });

      $(document).on('click', '.navbar-toggler', function () {
        var $toggle, div;
        $toggle = $(this);
        console.log('should be toggling');
        if (nowuiKit.misc.navbar_menu_visible == 1) {
          $('html').removeClass('nav-open');
          nowuiKit.misc.navbar_menu_visible = 0;
          $('#bodyClick').remove();
          setTimeout(function () {
            $toggle.removeClass('toggled');
          }, 550);
        } else {
          setTimeout(function () {
            $toggle.addClass('toggled');
          }, 580);
          div = '<div id="bodyClick"></div>';
          $(div).appendTo('body').click(function () {
            $('html').removeClass('nav-open');
            nowuiKit.misc.navbar_menu_visible = 0;
            setTimeout(function () {
              $toggle.removeClass('toggled');
              $('#bodyClick').remove();
            }, 550);
          });

          $('html').addClass('nav-open');
          nowuiKit.misc.navbar_menu_visible = 1;
        }
      });


      nowuiKit = {
        misc: {
          navbar_menu_visible: 0
        },

        checkScrollForTransparentNavbar: debounce(function () {
          if ($(document).scrollTop() > scroll_distance) {
            if (transparent) {
              transparent = false;
              $('.navbar[color-on-scroll]').removeClass('navbar-transparent');
            }
          } else {
            if (!transparent) {
              transparent = true;
              $('.navbar[color-on-scroll]').addClass('navbar-transparent');
            }
          }
        }, 17),

        initNavbarImage: function () {
          var $navbar = $('.navbar').find('.navbar-translate').siblings('.navbar-collapse');
          var background_image = $navbar.data('nav-image');

          if (background_image != undefined) {
            if ($(window).width() < 991 || $('body').hasClass('burger-menu')) {
              $navbar.css('background', "url('" + background_image + "')")
                .removeAttr('data-nav-image')
                .css('background-size', "cover")
                .addClass('has-image');
            } else {
              $navbar.css('background', "")
                .attr('data-nav-image', '' + background_image + '')
                .css('background-size', "")
                .removeClass('has-image');
            }
          }
        },


      }

      // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered. The function will be called after it stops being called for
      // N milliseconds. If `immediate` is passed, trigger the function on the
      // leading edge, instead of the trailing.

      function debounce(func, wait, immediate) {
        var timeout;
        return function () {
          var context = this,
            args = arguments;
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
          }, wait);
          if (immediate && !timeout) func.apply(context, args);
        };
      };
    }

    initTheme();

    // Get user details 
    this.$http.get('/api/users/general')
    .then(response => {
      this.$scope.user = response.data[0];
       this.$scope.city = this.$scope.user.Organization_Name;
      //Load GP Codes
      this.loadGPCodes();


    })
    .catch(err => {
      console.log(err);
    });


  


  }

  loadGPCodes(){
      // Load GP Codes 
      this.$http.get('/api/data/parcels/gpcodes')
      .then(response => {
        console.log(response.data);
        this.$scope.gpCodes = response.data;
        this.$scope.rowCollection = response.data;

   

        // Hands on Table
        var tableDiv = document.getElementById("handsonTable");
        var searchField = document.getElementById('search_field');
        var http = this.$http;
        var thisIsValid = this.$scope.thisIsValid;

        this.$scope.handsonTable = new Handsontable(tableDiv, {
          licenseKey: 'non-commercial-and-evaluation',
          data: this.$scope.rowCollection,
          allowInsertRow: false,
          colHeaders:
            ["RecID",
              "Jurisdiction Name",
              "General Plan Code",
              "General Plan Description",              
              "Generalized Planned Uses",
              "Max DUA",
              "Max FAR",
              "Max Height",
              "Units per Lot",
              "Code Map Color",
              "Last Edited By",
              "Last Edit Date"
            ],
          search: true,
          columns: [{
            data: "gp_recid",
            editor: false
          }, {
            data: "gp_jurisdiction",
            editor: false
          }, {
            data: "gp_code",
            type: "text"
          }, {
            data: "gp_description",
            type:"text"
           
          },{
            data: "gp_regional_code",
            editor: "chosen",
            type: 'autocomplete',
            chosenOptions: {
              data: [{
                id: 1,
                label: "Agriculture"
              }, {
                id: 2,
                label: "Single Family Residential"
              }, {
                id: 3,
                label: "Multi-Family Residential"
              }, {
                id: 4,
                label: "Mixed Use Residential"
              }, {
                id: 5,
                label: "Mixed Use Commercial"
              }, {
                id: 6,
                label: "Commercial"
              }, {
                id: 7,
                label: "Industrial"
              }, {
                id: 8,
                label: "Transportation"
              }, {
                id: 9,
                label: "Parks and Open Space"
              }, {
                id: 10,
                label: "Public and Institutional"
              }, {
                id: 11,
                label: "Conservation and Ecology Areas"
              }, {
                id: 12,
                label: "Specific or Special Plan Areas"
              }, {
                id: 999,
                label: "Unclassified"
              }]
            },
          }, {
            data: "gp_max_dua",
            type: 'numeric'
          }, {
            data: "gp_max_far",
            type: 'numeric'
          }, {
            data: "gp_max_height",
            type: 'numeric'
          }, {
            data: "gp_units_per_ot",
            type: 'numeric'
          },{
            data: "gp_map_color",
            type: 'text'
          }, {
            data: "editor_id",
            type: "text",
            editor: false           
          }, {
            data: "last_edited",
            type: "text",
            editor: false
          }],
          stretchH: 'all',
          width: '100%',
          autoWrapRow: true,
          rowHeaders: true,
          contextMenu: true,
          filters: true,
          dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'],
          multiColumnSorting: {
            indicator: true
          },
          exportFile: true,
          language: 'en-US',
          // enable column hiding
          // or
          hiddenColumns: {
            // set columns that are hidden by default
            columns: [0],
            // show where are hidden columns
            indicators: true
          },
          afterValidate: function (isValid, value, row, prop, source) {
            console.log(isValid);
            console.log(value);
            console.log(row);
            console.log(prop);
            console.log(source);
            thisIsValid = isValid;

          },
          afterFilter: function (filters) {
            console.log(filters);
            console.log($scope.handsonTable.countRows());

          },
          afterRemoveRow: function (index, amount, physicalRows, source) {
            console.log(index);
            console.log(amount);
            console.log(physicalRows);
            console.log(source);
          }
        });

        // Add Export Plugin 
        this.$scope.exportPlugin = this.$scope.handsonTable.getPlugin('exportFile');

        var $scope = this.$scope;
        Handsontable.dom.addEvent(searchField, 'keyup', function (event) {
          var search = $scope.handsonTable.getPlugin('search');
          var queryResult = search.query(this.value);

          console.log(queryResult);
          $scope.handsonTable.render();
        });

        
        var handsonTable = this.$scope.handsonTable;
        var setter = false;
        handsonTable.updateSettings({
          cells: function(row, col) {
           
          
            if (col === 12 && handsonTable.getDataAtCell(row, col) === false) {
             console.log(handsonTable.getDataAtCell(row, col))
             handsonTable.setDataAtCell(row, 0, 'value')
            } else if (col === 12 && handsonTable.getDataAtCell(row,col) === true) {
              handsonTable.setDataAtCell(row, 0, 'value')
            }
          
          }
        });
       
        handsonTable.addHook('afterChange', function (changes, source) {
          var updateData = [];
          console.log(source);
          console.log(thisIsValid);
          changes.forEach(([row, prop, oldValue, newValue]) => {
            var handsonUpdate = handsonTable.getDataAtRow(row);
            console.log(handsonUpdate);
            updateData.push({
              'gp_recid': handsonUpdate[0],
              'gp_jurisdiction': handsonUpdate[1],
              'gp_code': handsonUpdate[2],
              'gp_description': handsonUpdate[3],              
              'gp_regional_code': handsonUpdate[4],
              'gp_max_dua': handsonUpdate[6],
              'gp_max_far': handsonUpdate[7],
              'gp_max_height': handsonUpdate[8],
              'gp_units_per_lot': handsonUpdate[9],
              'gp_code_color': handsonUpdate[4],
            
            })
          });
          console.log(updateData);
          if (typeof thisIsValid === 'undefined') {
           console.log('its undefined');
           http.post('/api/data/landuse/codes/update/lu/update',updateData)
              .then(response => {
                console.log("283. ", response);
              })
              .catch(err => {
                console.log(err)
              })

          } else if (!thisIsValid) {
            console.log('its not valid');
          } else {
            // update data in database 
            http.post('/api/data/landuse/codes/update/lu/update',updateData)
              .then(response => {
                console.log("283. ", response);
              })
              .catch(err => {
                console.log(err)
              })
          }

        })


      })
      .catch(err => {
        console.log(err);
      })
  }

   // File Export 
   exportToFile() {
    this.$scope.exportPlugin.downloadFile('csv', {
      bom: false,
      columnDelimiter: ',',
      columnHeaders: true,
      exportHiddenColumns: false,
      exportHiddenRows: false,
      fileExtension: 'csv',
      filename: 'GPCodes-CSV-file_[YYYY]-[MM]-[DD]',
      mimeType: 'text/csv',
      rowDelimiter: '\r\n',
      rowHeaders: true
    });
  }
}

export default angular.module('hessApplicationApp.gp', [uiRouter])
  .config(routes)
  .component('gp', {
    template: require('./gp.html'),
    controller: GpComponent,
    controllerAs: 'gpCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/gp/gp.component.js